// extracted by mini-css-extract-plugin
export default {"containerStyle":"alert_containerStyle__-Rs1k","iconTextContainer":"alert_iconTextContainer__r4vBW"};